import React from 'react';
import {
  Button,
  Flex,
  Heading,
  Image,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

import { useHistory } from 'react-router-dom';
import BankAppPage from '../../layout/BankAppPage';

import notfoundDark from '../../assets/Notfound/error404_dark.svg';
import notfoundLight from '../../assets/Notfound/error404_light.svg';

const Notfound: React.FC = () => {
  const history = useHistory();
  const notfound = useColorModeValue(notfoundLight, notfoundDark);

  return (
    <BankAppPage>
      <Flex
        flex="1"
        flexDir="column"
        align="center"
        justify="space-around"
        pb="6"
      >
        <div>
          <Heading textAlign="center">
            404: A página que você está procurando não está aqui
          </Heading>
          <Text textAlign="center">
            Ou você tentou um caminho obscuro ou veio aqui por engano. Seja o
            que for, tente usar a navegação.
          </Text>
        </div>
        <Image w="400px" src={notfound} alt="404 - Notfound" />
        <Button
          variant="outline"
          fontSize="sm"
          onClick={() => history.push('/dashboard')}
        >
          Voltar para Visão Geral
        </Button>
      </Flex>
    </BankAppPage>
  );
};

export default Notfound;
